import axios from 'axios';
import {INVENTORY_FETCH_ASSET_START, INVENTORY_FETCH_ASSET_SUCCESS, INVENTORY_FETCH_ASSET_FAILURE} from '../../actions/actionTypes';


const assetFetchStart = () => ({type: INVENTORY_FETCH_ASSET_START});

const assetFetchSuccess = (asset) => ({type: INVENTORY_FETCH_ASSET_SUCCESS, payload: asset});

const assetFetchFailure = (error) => ({type: INVENTORY_FETCH_ASSET_FAILURE, error});

export const fetchAsset = (assetId) => {
    return async (dispatch) => {
        if(assetId){
            dispatch(assetFetchStart());
            try {
                const url = `${process.env.API}/inventory/asset/${assetId}`
                const response = await axios.get(url);
                dispatch(assetFetchSuccess(response?.data))
            } catch (error) {
                dispatch(assetFetchFailure(error));
            }
        }
    };
};